/**
 * Dataplatform SDK.
 * 추후 별도의 repository로 분리 예정, PC, MO 공통으로 사용
 */
var Dataplatform = {
    CONSTANTS: {
        DATAPLATFORM_STORAGE_KEYS: {
            VISITOR_ID: "df_vi",
            SESSION_ID: "df_si",
        },
        DATAPLATFORM_SESSION_TIMEOUT: 30 * 60 * 1000,
        DATAPLATFORM_VERSION: "v1",
        DATAPLATFORM_URL : "https://api.dp.oliveyoung.co.kr",
    },
    DATAPLATFORM_API_KEY: "",
    userProperties: {
        user_id: "",
        visitor_id: "",
        device: "",
    },
    getProperties : function (properties) {
        return {
            timestamp: Date.now(),
            version: "v1",
            user_agent: navigator.userAgent,
            url: location.href,
            device: Dataplatform.userProperties.device,
            user_id: Dataplatform.userProperties.user_id,
            visitor_id: Dataplatform.userProperties.visitor_id,
            session_id: "",
            event_type: properties.event_type,
            event_properties: properties.event_properties,
        }
    },

    eventLogQueue : [],

    init : function(key, hashedMbrNo, options) {
        if(!key) {
            throw "Dataplatform API KEY IS MANDATORY.";
        }

        if (hashedMbrNo) {
            Dataplatform.userProperties.user_id = hashedMbrNo;
        }

        if (options && options.dataplatformBaseURL) {
            Dataplatform.CONSTANTS.DATAPLATFORM_URL = options.dataplatformBaseURL;
        }

        Dataplatform.DATAPLATFORM_API_KEY = key;

        const visitorId = Dataplatform.initVisitorId();
        Dataplatform.userProperties.visitor_id = visitorId;

        Dataplatform.userProperties.device = "MO";

        Dataplatform.initSessionId(visitorId);

        Dataplatform.consume();
    },

    track : function (eventName, eventProperties) {
        const data = Dataplatform.getProperties({
            event_type: eventName,
            event_properties: eventProperties,
        });

        Dataplatform.eventLogQueue.push(data);

        if (data.visitor_id) {
            Dataplatform.consume();
        }
    },

    consume : function() {
        while (Dataplatform.eventLogQueue.length > 0) {
            var data = {};
            Object.assign(data, Dataplatform.userProperties);
            Object.assign(data, Dataplatform.eventLogQueue.shift());
            data.session_id = Dataplatform.initSessionId(Dataplatform.userProperties.visitor_id);

            Dataplatform.postDataPlatformLogEvent(data);
        }
    },

    initVisitorId : function () {
        var visitorId = Dataplatform.util.localStorageManager.getWithoutExpiry(Dataplatform.CONSTANTS.DATAPLATFORM_STORAGE_KEYS.VISITOR_ID);
        if (!visitorId) {
            visitorId = Dataplatform.util.generateUUID();
            Dataplatform.util.localStorageManager.setWithoutExpiry(Dataplatform.CONSTANTS.DATAPLATFORM_STORAGE_KEYS.VISITOR_ID, visitorId);
        }
        return visitorId;
    },

    initSessionId : function (visitorId) {
        const now = Date.now();
        const { sessionId, timestamp } = Dataplatform.util.sessionStorageManager.getItem(Dataplatform.CONSTANTS.DATAPLATFORM_STORAGE_KEYS.SESSION_ID) || {};
        if (!sessionId || now - timestamp > Dataplatform.CONSTANTS.DATAPLATFORM_SESSION_TIMEOUT) {
            // sessionId가 없으면 새로 생성한다 or sessionId가 있으나 expired가 되었으면 새로 생성한다.
            const newSessionId = Dataplatform.util.generateSessionId(visitorId);
            Dataplatform.util.sessionStorageManager.setItem(Dataplatform.CONSTANTS.DATAPLATFORM_STORAGE_KEYS.SESSION_ID, { sessionId: newSessionId, timestamp: now });
            return newSessionId;
        }

        // sessionId가 있고, expired 되지 않았으면, timestamp만 업데이트 한다.
        Dataplatform.util.sessionStorageManager.setItem(Dataplatform.CONSTANTS.DATAPLATFORM_STORAGE_KEYS.SESSION_ID, { sessionId, timestamp: now });
        return sessionId;
    },

    /**
     * @see [dataPlatform log - 로그전송 ]{@link https://dataplatform.oliveyoung.co.kr/#/log/post_v1_log_event }
     */
    postDataPlatformLogEvent : (params, callback) => {
        $.ajax({
            type: "POST",
            contentType: "application/json",
            url: Dataplatform.CONSTANTS.DATAPLATFORM_URL + "/v1/log/event",
            data: JSON.stringify(params),
            dataType : 'json',
            async: true,
            headers: {'X-Access-Token': Dataplatform.DATAPLATFORM_API_KEY},
            success: function(){
                callback && callback();
            }
        });
    },

    util : {
        /**
         * generate UUID from ChatGPT
         * @returns uuid
         */
        generateUUID: () => {
            return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
                const r = (Math.random() * 16) | 0,
                    v = c == "x" ? r : (r & 0x3) | 0x8;
                return v.toString(16);
            });
        },

        /**
         * generate sessionId
         * @returns {string} sessionId
         */
        generateSessionId: (id) => {
            return id + "_" + String(Date.now());
        },

        /**
         * session storage util
         * @returns {string} sessionId
         */
        sessionStorageManager: {
            setItem: function (key, value) {
                sessionStorage.setItem(key, JSON.stringify(value));
            },
            getItem: function (key) {
                return JSON.parse(sessionStorage.getItem(key));
            },
            removeItem: function (key) {
                sessionStorage.removeItem(key);
            },
        },
        localStorageManager: {
            setWithoutExpiry : function (key, value, ttl) {
                var item = {
                    value: value,
                };

                localStorage.setItem(key, JSON.stringify(item));
            },

            /**
             * 만료기간이 없는 localStorage값을 가져온다.
             */
            getWithoutExpiry : function(key) {
                const itemStr = localStorage.getItem(key);

                // if the item doesn't exist, return null
                if (!itemStr) {
                    return null;
                }

                try {
                    const item = JSON.parse(itemStr);
                    return item.value;
                } catch (e) {
                    // 손상된 값은 없는 것과 동일하게 취급하여 재생성 유도
                    return null;
                }
            },
        }
    }
};

